import {
  GET_SCRATCH_TICKETS_REQUEST,
  GET_SCRATCH_TICKETS_SUCCESS,
  GET_SCRATCH_TICKETS_FAILURE,
} from 'Store/constants';
  
    
const initialState = {
  data: null,
  isLoading: null,
  error: null
};
    
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_SCRATCH_TICKETS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_SCRATCH_TICKETS_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case GET_SCRATCH_TICKETS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};